import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  loginRequest,
  loginSuccess,
  loginFailure,
  registerRequest,
  registerSuccess,
  registerFailure,
} from '../slices/authSlice';
import { showLoading, hideLoading } from '../slices/loadingSlice'; // ✅ ADD THIS

const API_BASE_URL =  process.env.REACT_APP_API_BASE_URL;
const API_URL = `${API_BASE_URL}/api/auth`;

function* loginSaga(action) {
  try {
    yield put(showLoading('Logging in...')); // ✅ ADD THIS
    
    const response = yield call(axios.post, `${API_URL}/login`, action.payload);
    const { token, id, username, email, role } = response.data;
    
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    yield put(loginSuccess({
      token,
      user: { id, username, email, role },
    }));
  } catch (error) {
    yield put(loginFailure(error.response?.data?.message || 'Login failed'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

function* registerSaga(action) {
  try {
    yield put(showLoading('Creating your account...')); // ✅ ADD THIS
    
    const response = yield call(axios.post, `${API_URL}/register`, action.payload);
    const { token, id, username, email, role } = response.data;
    
    localStorage.setItem('token', token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    
    yield put(registerSuccess({
      token,
      user: { id, username, email, role },
    }));
  } catch (error) {
    yield put(registerFailure(error.response?.data?.message || 'Registration failed'));
  } finally {
    yield put(hideLoading()); // ✅ ADD THIS
  }
}

export default function* authSaga() {
  yield takeLatest(loginRequest.type, loginSaga);
  yield takeLatest(registerRequest.type, registerSaga);
}